// API Configuration
export const API_CONFIG = {
  //check local or dev use process.env.NODE_ENV === 'development' ? 
  BASE_URL:   'https://td.giangdc.company/Admin/GDCService.asmx',
  KEY_PASS: 'Gdc825@',
  TIMEOUT: 10000
};

// User Types (based on API response)
export const USER_TYPES = {
  CENTER: 1,
  DISPATCHER: 2,
  DRIVER: 3,
  CUSTOMER: 4,
  ADMIN: 5
};

export const USER_TYPE_TEXT = {
  1: 'Trung tâm',
  2: 'Điều vận', 
  3: 'Lái xe',
  4: 'Khách hàng',
  5: 'Admin'
};

// Shipment Status (based on API response trangthai field)
export const SHIPMENT_STATUS = {
  WAITING_CONFIRMATION: 0, // Chờ xác nhận
  ACCEPTED: 1,            // Đã nhận chuyến
  IN_DELIVERY: 2,         // Đang giao
  COMPLETED: 5,           // Hoàn thành
  CANCELLED: 9            // Hủy
};

export const SHIPMENT_STATUS_TEXT = {
  0: 'Chờ xác nhận',
  1: 'Đã nhận chuyến',
  2: 'Đang giao',
  5: 'Hoàn thành',
  9: 'Hủy'
};

export const SHIPMENT_STATUS_COLORS = {
  0: 'bg-blue-500',      // Chờ xác nhận - xanh dương
  1: 'bg-green-500',     // Đã nhận chuyến - xanh lá
  2: 'bg-yellow-500',    // Đang giao - vàng
  5: 'bg-white border-2 border-gray-300', // Hoàn thành - trắng viền
  9: 'bg-red-500'        // Hủy - đỏ
};

// Transport Types (based on API response loaivantai field)
export const TRANSPORT_TYPES = {
  SINGLE_POINT: 1,    // Giao một điểm
  MULTIPLE_POINTS: 2, // Giao nhiều điểm
  BY_DAY: 3          // Theo ngày
};

export const TRANSPORT_TYPE_TEXT = {
  1: 'Giao một điểm',
  2: 'Giao nhiều điểm',
  3: 'Theo ngày'
};

// Navigation Screens
export const SCREENS = {
  LOGIN: 'login',
  CALENDAR: 'calendar',
  DETAIL: 'detail',
  HISTORY: 'history',
  CREATE_SHIPMENT: 'create_shipment',
  REPORT: 'report',
  NOTIFICATION: 'notification', // Notification screen
  SETTINGS: 'settings' // NEW: Settings screen
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_DATA: 'userData',
  SHIPMENTS: 'shipments',
  SETTINGS: 'settings'
};

// API Endpoints
export const API_ENDPOINTS = {
  CHECK_LOGIN: 'CheckLogin',
  CHANGE_PASSWORD: 'ChangePassword',
  GET_SHIPMENT_DRIVER: 'GetInfor_ShipmentDriver',
  GET_SHIPMENT_DETAIL: 'GetInforDetail_TruckRoute',
  UPDATE_STATUS: 'UpdateStatus_TruckRoute',
  SAVE_SHIPMENT: 'SAVE_TruckRoute',
  GET_CUSTOMERS: 'GetInfor_Customer',
  GET_DRIVERS: 'GetInfor_Driver',
  GET_PAYLOAD: 'GetInfor_Payload',
  GET_TRUCKS: 'GetInfor_Truck',
  GET_SHIPPING_ADDRESS: 'GetInfor_ShippingAddress',
  GET_PRICE: 'GetInfor_Price',
  UPLOAD_IMAGE: 'UploadImage',
  GET_SHIPMENT_IMAGES: 'GetInforImage_TruckRoute',
  DELETE_IMAGE: 'DeleteImage_TruckRoute',
  SAVE_DEVICE: 'SaveDevice'
};


export const IMAGE_TYPES = {
  AVATAR: 'avatar',
  SHIPMENT: 'shipment',
  DOCUMENT: 'document',
  SIGNATURE: 'signature'
};


export const IMAGE_CONSTRAINTS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILES_PER_UPLOAD: 10,
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  MAX_WIDTH: 1024,
  MAX_HEIGHT: 768,
  COMPRESSION_QUALITY: 0.8
};


// Date Formats
export const DATE_FORMATS = {
  API: 'DD-MM-YYYY',      // Format used by API: "27-05-2025"
  DISPLAY: 'DD/MM/YYYY',  // Format for display
  ISO: 'YYYY-MM-DD'       // ISO format for Date objects
};

// API Response Structure
export const API_RESPONSE_STRUCTURE = {
  SUCCESS_STATUS: 'Success',
  ERROR_STATUS: 'Error',
  STATUS_INDEX: 0,
  MESSAGE_INDEX: 1,
  DATA_INDEX: 2
};

// Shipment Fields (based on API response structure)
export const SHIPMENT_FIELDS = {
  STT: 'stt',
  ID: 'idChuyenXe',
  INPUT_DATE: 'ngaynhap',
  DELIVERY_DATE: 'ngaynhan',
  PO_NUMBER: 'soPO',
  STATUS: 'trangthai',
  TRANSPORT_TYPE: 'loaivantai',
  VEHICLE_NUMBER: 'bienso',
  REGISTRATION_NUMBER: 'sodangky',
  CONTAINER_NUMBER: 'socuathung',
  DRIVER_NAME: 'nhansu',
  DRIVER_BIRTH: 'ngaysinh',
  DRIVER_ID: 'CCCD',
  DRIVER_ID_DATE: 'ngaycapCCCD',
  DRIVER_ADDRESS: 'diachithuongtru',
  DRIVER_PHONE: 'dienthoaiLX',
  CUSTOMER: 'khachhang',
  CUSTOMER_1: 'khachhang1',
  CUSTOMER_2: 'khachhang2',
  CUSTOMER_3: 'khachhang3',
  CUSTOMER_4: 'khachhang4',
  PICKUP_ADDRESS: 'diachinhan',
  DELIVERY_ADDRESS_1: 'diachigiao1',
  DELIVERY_ADDRESS_2: 'diachigiao2',
  DELIVERY_ADDRESS_3: 'diachigiao3',
  DELIVERY_ADDRESS_4: 'diachigiao4',
  MODIFIED_DATE: 'ngaysua',
  MODIFIED_BY: 'nguoisua',
  TRO_CAP_CHUYEN: 'trocapchuyen'
};

// Customer Fields (based on GetInfor_Customer API response)
export const CUSTOMER_FIELDS = {
  ID: 'idKhachHang',
  CODE: 'maKhachHang',
  NAME: 'tenKhachHang',
  ADDRESS: 'diachi',
  DELIVERY_ADDRESS: 'diachigiaohang',
  PHONE: 'dienthoai',
  CONTACT: 'lienhe',
  MAP_LINK: 'linkmap'
};

// Driver Fields (based on GetInfor_Driver API response)
export const DRIVER_FIELDS = {
  ID: 'idNhanSu',
  ID_CARD: 'soCCCD',
  NAME: 'tenNhanSu',
  PHONE: 'dienthoai',
  ADDRESS: 'diachi',
  BIRTH_DATE: 'ngaysinh',
  USER_ID: 'UserID'
};

// Truck Fields (based on GetInfor_Truck API response)
export const TRUCK_FIELDS = {
  ID: 'idXe',
  LICENSE_PLATE: 'bienso',
  DRIVER_ID: 'idLaixe',
  PAYLOAD_ID: 'idTrongTai',
  PAYLOAD: 'trongTai'
};

// Payload Fields (based on GetInfor_Payload API response)
export const PAYLOAD_FIELDS = {
  ID: 'idTrongTai',
  WEIGHT: 'trongTai'
};

// Shipping Address Fields (based on GetInfor_ShippingAddress API response)
export const SHIPPING_ADDRESS_FIELDS = {
  ID: 'idDiaChi',
  CODE: 'maDiaChi',
  ADDRESS: 'diaChi',
  CONTACT: 'lienhe',
  MAP_LINK: 'linkmap'
};

// Detailed Shipment Fields (based on GetInforDetail_TruckRoute API response)
export const SHIPMENT_DETAIL_FIELDS = {
  INPUT_DATE: 'ngaynhap',
  PICKUP_DATE: 'ngaynhan',
  DELIVERY_DATE_1: 'ngaygiao1',
  DELIVERY_DATE_2: 'ngaygiao2',
  DELIVERY_DATE_3: 'ngaygiao3',
  DELIVERY_DATE_4: 'ngaygiao4',
  CUSTOMER_ID: 'idKhachHang',
  PICKUP_CUSTOMER_ID: 'idKhachHangNhan',
  DELIVERY_CUSTOMER_ID_1: 'idKhachHangGiao1',
  DELIVERY_CUSTOMER_ID_2: 'idKhachHangGiao2',
  DELIVERY_CUSTOMER_ID_3: 'idKhachHangGiao3',
  DELIVERY_CUSTOMER_ID_4: 'idKhachHangGiao4',
  TRANSPORT_TYPE: 'loaivantai',
  PAYLOAD_ID: 'idTrongTai',
  TRUCK_ID: 'idXe',
  DRIVER_ID: 'idLaiXe',
  PICKUP_ADDRESS_ID: 'idDiaChiLayHang',
  DELIVERY_ADDRESS_ID_1: 'idDiaChiGiaoHang1',
  DELIVERY_ADDRESS_ID_2: 'idDiaChiGiaoHang2',
  DELIVERY_ADDRESS_ID_3: 'idDiaChiGiaoHang3',
  DELIVERY_ADDRESS_ID_4: 'idDiaChiGiaoHang4',
  PICKUP_ADDRESS: 'diaChiLayHang',
  DELIVERY_ADDRESS_1: 'diaChiGiaoHang1',
  DELIVERY_ADDRESS_2: 'diaChiGiaoHang2',
  DELIVERY_ADDRESS_3: 'diaChiGiaoHang3',
  DELIVERY_ADDRESS_4: 'diaChiGiaoHang4',
  PICKUP_CONTACT: 'lienhenhan',
  DELIVERY_CONTACT_1: 'lienhegiao1',
  DELIVERY_CONTACT_2: 'lienhegiao2',
  DELIVERY_CONTACT_3: 'lienhegiao3',
  DELIVERY_CONTACT_4: 'lienhegiao4',
  PICKUP_MAP_LINK: 'linkmapnhan',
  DELIVERY_MAP_LINK_1: 'linkmapgiao1',
  DELIVERY_MAP_LINK_2: 'linkmapgiao2',
  DELIVERY_MAP_LINK_3: 'linkmapgiao3',
  DELIVERY_MAP_LINK_4: 'linkmapgiao4',
  PICKUP_HOUR_1: 'gionhan1',
  PICKUP_MINUTE_1: 'phutnhan1',
  DELIVERY_HOUR_1: 'giogiao1',
  DELIVERY_MINUTE_1: 'phutgiao1',
  DELIVERY_HOUR_2: 'giogiao2',
  DELIVERY_MINUTE_2: 'phutgiao2',
  DELIVERY_HOUR_3: 'giogiao3',
  DELIVERY_MINUTE_3: 'phutgiao3',
  DELIVERY_HOUR_4: 'giogiao4',
  DELIVERY_MINUTE_4: 'phutgiao4',
  STATUS: 'trangthai',
  VALUE: 'giatri',
  NOTES: 'ghichu'
};
